import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./HomeHeroSection.module.css";


import { useNavigate } from "react-router-dom";

const PRESS_DATA = [
  {
    source: "Zee News",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/zee-english-n%201.png", // place logo image URL here
    text: "Baglami is a culinary journey that takes you on a gastronomic adventure around the world.",
    link: "https://zeenews.india.com/mumbai/baglami-culinary-meets-opulence-in-mumbais-bkc-2760585.html/amp",
  },
  {
    source: "Travel & Leisure Asia",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/TL-New-logo-Sept-2020-Black.png", // place logo image URL here
    text: "Serving a feast for your palate as well as your eyes and soul.",
    link: "https://www.travelandleisureasia.com/in/dining/aesthetic-restaurants-in-mumbai/amp/",
  },
  {
    source: "Grazia",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/svgviewer-output%201.png", // place logo image URL here
    text: "Blending comfort and craftsmanship to transform familiar flavours into culinary surprises, Baglami stages a modern Asian-forward tasting journey.",
    link: "https://www.grazia.co.in/lifestyle/weekend-guide-everywhere-you-can-eat-sip-and-celebrate-this-weekend-15032.amp",
  },
  {
    source: "Curly Tales",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/curlytales-logo-150x71.webp", // place logo image URL here
    text: "Golden hour may end but the glow at Baglami stays.",
    link: "https://curlytales.com/best-romantic-restaurants-in-mumbai-perfect-for-a-date/amp/",
  },
  {
    source: "Lifestyle Asia",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/logo%20(1)%20(1).png", // place logo image URL here
    text: "Experience warmth, comfort, and modern Asian-forward flavours with Baglami’s.",
    link: "https://www.lifestyleasia.com/ind/dining/new-menus-in-mumbai-in-february-2026/amp/",
  },
  {
    source: "Elle",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/2025-03-08t065857820z-elle-gourmet-logo.webp", // place logo image URL here
    text: "Warm, rich, and crafted for the season of love.",
    link: "https://ellegourmet.in/food/reserve-before-its-too-late-55-romantic-valentines-day-menus-and-experiences-in-india-11089784",
  },
  {
    source: "Outlook Luxe",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/logo_v2%201.png", // place logo image URL here
    text: "Global-cuisine restaurant and bar, Baglami, rings in the Chinese New Year with a limited-edition menu that leans into indulgence with comfort.",
    link: "https://luxe.outlookindia.com/food-travel/food/chinese-new-year-2026-11-best-restaurants-in-i",
  },
  {
    source: "News 18",
    logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/WhatsApp%20Image%202026-05-07%20at%204.06.png", // place logo image URL here
    text: "From elegant interiors to refined hospitality, Baglami in BKC is fast emerging as Mumbai’s go-to venue for private gatherings, industry meets and curated luxury events.",
    link: "https://www.news18.com/amp/lifestyle/food/spotlight-on-baglami-bkc-a-contemporary-destination-for-curated-experiences-9946560.html",
  },
];

const HomeHeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(3);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const navigate = useNavigate()

  const totalRealItems = PRESS_DATA.length;
  const extendedPressData = [...PRESS_DATA, ...PRESS_DATA.slice(0, itemsToShow)];

  useEffect(() => {
    const handleResize = () => {
      setItemsToShow(window.innerWidth <= 1024 ? 1 : 3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setTransitionEnabled(true);
      setCurrentIndex((prev) => prev + 1);
    }, 3500);
    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    if (currentIndex === totalRealItems) {
      const timer = setTimeout(() => {
        setTransitionEnabled(false);
        setCurrentIndex(0);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, totalRealItems]);

  const handleNavigate = () => {
    navigate('/reservation')
  }

  const navigateToLocation = () => {
    window.open('https://maps.app.goo.gl/JnBvBXyDMHoavThm8')
  }

  return (
    <div className={styles.heroWrapper}>
      {/* HERO SECTION */}
      <section className={styles.heroTop}>
        <motion.h1
          className={styles.heroTitle}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Where Culinary Art  <br />  Meets Timeless Luxury.
        </motion.h1>

        <div className={styles.heroImages}>
          <motion.img
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/Miso%20ramen.jpg"} className={styles.leftImg} alt="Hero Left"
          />
          <motion.img
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
            src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/Home%20page%20(1).jpg"} className={styles.mainImg} alt="Hero Main"
          />
          <motion.img
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/DSC08216.jpg"} className={styles.rightImg} alt="Hero Right"
          />
        </div>
      </section>

      {/* PRESS SECTION */}
      <section
        className={styles.pressSection}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className={styles.pressViewport}>
          <div
            className={styles.pressTrack}
            style={{
              transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)`,
              transition: transitionEnabled ? "transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)" : "none"
            }}
          >
            {extendedPressData.map((item, index) => (
              <div
                key={index}
                className={styles.pressSlide}
                style={{ flex: `0 0 ${100 / itemsToShow}%` }}
              >
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.pressItem}
                >
                  {item.logo ? (
                    <img
                      src={item.logo}
                      alt={item.source}
                      className={styles.pressLogo}
                    />
                  ) : (
                    <h4>{item.source}</h4>
                  )}
                  <p>"{item.text}"</p>
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.dots}>
          {PRESS_DATA.map((_, index) => (
            <span
              key={index}
              className={(currentIndex % totalRealItems) === index ? styles.activeDot : ""}
              onClick={() => {
                setTransitionEnabled(true);
                setCurrentIndex(index);
              }}
            ></span>
          ))}
        </div>
      </section>

      {/* CHEF SECTION */}
      <section className={styles.chefSection}>
        <motion.div
          className={styles.chefImage}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/IMG_0490.JPG%20(1).jpg"} alt="Chef" />
        </motion.div>

        <motion.div
          className={styles.chefContent}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>A more refined expression of the flavours people return to.</h2>
          <div className={styles.chefButtons}>
            <button onClick={handleNavigate} className={styles.reservationBtn}>Reservation</button>
            <button onClick={navigateToLocation} className={styles.directionBtn}>Get Direction →</button>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default HomeHeroSection;